export const actionTypes = {
    ANIMATED_LAYER_SET_ACTIVE: 'ANIMATED_LAYER/SET_ACTIVE',
    ANIMATED_LAYERS: 'ANIMATED_LAYER/ANIMATED_LAYERS',
}